import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";
import FetchUtil from "../utils/FetchUtil";

function DelegateLocationTableRow({ index, selectedDelegate, primaryBuyerCompanyId, secondaryBuyerCompanyId, delegateLocationItem, handleSubmit, setError, t, setAdd, setEdit, oddIdx }) {
    const navigate = useNavigate();
    const [supplierKey, setSupplierKey] = useState(selectedDelegate.companyId);
    const [delegateKey, setDelegateKey] = useState(selectedDelegate.delegateKey);
    const [isSubmit, setIsSubmit] = useState(false);
    const [locations, setLocations] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);
    const [locationKey, setLocationKey] = useState(0);
    const [locationLoaded, setLocationLoaded] = useState(false);
    const [locationSelected, setLocationSelected] = useState({ name: "locationKey", label: "", value: 0 });

    useEffect(() => {
		fetchLocations(selectedDelegate.companyId, selectedDelegate.parentCompanyKey);
    }, []);

	
    function fetchLocations(selectedSupplierKey, parentCompanyKey) {
        setError("");
        let buyerCompanyId = (parentCompanyKey && parentCompanyKey != '0') ? parentCompanyKey : primaryBuyerCompanyId;
        if (!selectedSupplierKey || selectedSupplierKey === 0 || !buyerCompanyId) {
            return;
        }
        setLocations([]);
        setLocationKey(0);
        setLocationOptions([]);
        setLocationSelected({ ...locationSelected, label: "", value: 0 });
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: false,
                supplierKey: selectedSupplierKey,
                buyerKey: buyerCompanyId,
				includeInactivePartner: true
            }),
        };
        try {
            FetchUtil.fetchAPI("GetPartnerLocations", "/Service/CompanyService/GetPartnerLocations", requestOptions, retrieveWorkLocationSuccess, retrieveWorkLocationFail);
        } catch (error) {
            throw new Error(error.message);
        }
    }

    function retrieveWorkLocationFail(redirect) {
        if (redirect) {
            navigate("/");
        }
        setError(t("error.locNotRetrieved"));
    }

    function retrieveWorkLocationSuccess(responseData) {
        let getPartnerLocationResponse;
        if (responseData) {
            getPartnerLocationResponse = responseData.getPartnerLocationResponse;
            if (getPartnerLocationResponse && getPartnerLocationResponse.errorCode === "0") {
                setLocationValues(getPartnerLocationResponse.locations);
                if (getPartnerLocationResponse.locations) {
                    setLocations(getPartnerLocationResponse.locations.slice());
                }
            } else if (getPartnerLocationResponse && getPartnerLocationResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getPartnerLocationResponse) {
                setError(t("error.error") + " " + getPartnerLocationResponse.errorMessage);
            } else {
                setError(t("error.system.fetch"));
            }
        }
    }
    function setLocationValues(locations) {
        let locationValue = {};
        let selectedLocationId = 0;
        let selectedLocationName = "";
        if ((delegateLocationItem && Object.keys(delegateLocationItem).length > 0)) {
            selectedLocationId = delegateLocationItem.locationKey;
        }
        let locationOptionList = [];
        locationOptionList.push({ label: "", value: 0 });
        if (locations && locations.length > 0) {
            locations.map((location, idx) => {
				if(location.companyId != secondaryBuyerCompanyId){
	                locationValue.label = location.locationName + " - " + location.departmentName;
	                locationValue.value = location.locationKey;
	                locationOptionList.push(locationValue);
	                locationValue = {};
	            }
                if (location.locationKey == selectedLocationId) {
                    selectedLocationName = location.locationName + " - " + location.departmentName;
                }
            });
        }
        setLocationOptions(locationOptionList);
        setLocationLoaded(true);
        if (selectedLocationName !== "") {
            setLocationSelected({ ...locationSelected, label: selectedLocationName, value: selectedLocationId });
            setLocationKey(selectedLocationId);
        } else {
            setLocationSelected({ ...locationSelected, label: "", value: 0 });
            setLocationKey(0);
        }
    }
    const locationHandler = (selectedOption) => {
        let selectedLocationKey = selectedOption ? selectedOption.value : 0;
        let selectedLocationName = selectedOption ? selectedOption.label : "";

        setLocationKey(selectedLocationKey);
        setLocationSelected({ ...locationSelected, label: selectedLocationName, value: selectedLocationKey });
    }
    function submitComplete() {
        setIsSubmit(false);
    }
    function submitRow() {
        setError("");
        setIsSubmit(true);
        let action = 1;
        let delegateLocationKey = 0;
        let editDelegateKey = delegateKey;
        if ((delegateLocationItem && Object.keys(delegateLocationItem).length > 0)) {
            action = 2;
            delegateLocationKey = delegateLocationItem.delegateLocationKey;
            if (editDelegateKey == 0) {
                editDelegateKey = delegateLocationItem.delegateKey;
            }
        }
        if (!supplierKey || supplierKey === 0) {
            setError(t("error.supplier.Reqd"));
            setIsSubmit(false);
        } else if (!locationKey || locationKey === 0) {
            setError(t("error.location.Reqd"));
            setIsSubmit(false);
        } else {
            let initialValues = {
                delegateLocationKey: delegateLocationKey,
                companyKey: supplierKey,
                locationKey: locationKey,
                action: action,
                delegateKey: editDelegateKey,
            };
            handleSubmit(action, initialValues, submitComplete);
        }

    }
    function submitCancel() {
        setError("");
        setAdd(false);
        setEdit(false);
        setIsSubmit(false);
    }
    return (
        <tr key={index}>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                {selectedDelegate ? 
                	((selectedDelegate.parentCompanyName && selectedDelegate.parentCompanyName != "") ? 
                		selectedDelegate.parentCompanyName + " <- " : "") + selectedDelegate.companyName : delegateLocationItem.companyName}
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                {locationLoaded ? <Select
                    name="locationKey"
                    options={locationOptions}
                    onChange={locationHandler}
                    placeholder={""}
                    value={locationSelected}
                    isSearchable={true}
                    isClearable={true}
                    className="myselect"
                    inputId="locationKey-input"
                    styles={ddStyles}
                />
                    : <></>}
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <div id="submit-spinner"
                    className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
                >
                </div>
                <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>
                <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
        </tr>
    )

}
export default DelegateLocationTableRow;